import API_URLS from '../../../../config/apiConfig';
import type {
  ReplaceStoreDetailsFeatureFlagAssignmentsRequest,
  StoreDetailsFeatureFlagApiClientApplication,
  StoreDetailsFeatureFlagsApiResponse,
} from '../../../../types/features/storeDetails/featureFlags';
import { apiGet, apiPut } from '../../../../utils/apiUtils';
import { ErrorHandler } from '../../../../utils/errorHandler';

class StoreDetailsFeatureFlagsService {
  async getStoreFeatureFlags(
    storeId: string,
    clientApplication: StoreDetailsFeatureFlagApiClientApplication,
  ): Promise<StoreDetailsFeatureFlagsApiResponse> {
    try {
      const searchParams = new URLSearchParams({ client_application: clientApplication });
      const response = await apiGet(`${API_URLS.ADMIN_STORE_FEATURE_FLAGS(storeId)}?${searchParams.toString()}`);
      return response as StoreDetailsFeatureFlagsApiResponse;
    } catch (error) {
      const message = ErrorHandler.handleApiError(error, 'Failed to load store feature flags', false);
      throw new Error(message || 'Failed to load store feature flags');
    }
  }

  async replaceStoreFeatureFlagAssignments(
    storeId: string,
    payload: ReplaceStoreDetailsFeatureFlagAssignmentsRequest,
  ): Promise<void> {
    try {
      await apiPut(API_URLS.ADMIN_STORE_FEATURE_FLAGS(storeId), payload);
    } catch (error) {
      const message = ErrorHandler.handleApiError(error, 'Failed to save store feature assignments', false);
      throw new Error(message || 'Failed to save store feature assignments');
    }
  }
}

const storeDetailsFeatureFlagsService = new StoreDetailsFeatureFlagsService();

export default storeDetailsFeatureFlagsService;
